import React, { useState, Fragment, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import { ToastContainer, toast } from 'react-toastify';
import moment from 'moment';
import API from '../../services/API';

const GatePage = () => {
  const [gates, setGates] = useState([]);
  const [modalAddGate, setModalAddGate] = useState(false);
  const [newGate, setNewGate] = useState({
    gate_name: '',
    description: '',
  });

  const toggleAddGateModal = () => setModalAddGate(!modalAddGate);

  const fetchGates = () => {
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      token: localStorage.getItem('token'),
    };

    API.get('/attendance/gateList', { headers })
      .then((response) => {
        if (response.data.response_code === 1000) {
          setGates(response.data.data || []);
        } else {
          toast.error(response.data.message || 'Gagal mendapatkan senarai pintu masuk', {
            autoClose: 5000,
          });
        }
      })
      .catch(() => {
        toast.error('Ralat semasa mendapatkan senarai pintu masuk', {
          autoClose: 5000,
        });
      });
  };

  const handleDeleteGate = (id) => {
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      token: localStorage.getItem('token'),
    };

    API.delete(`/attendance/gate/${id}`, { headers })
      .then((response) => {
        if (response.data.response_code === 1000) {
          toast.success('Pintu masuk berjaya dipadam', { autoClose: 5000 });
          fetchGates();
        } else {
          toast.error(response.data.message || 'Gagal memadam pintu masuk', {
            autoClose: 5000,
          });
          fetchGates();
        }
      })
      .catch(() => {
        toast.error('Ralat semasa memadam pintu masuk', { autoClose: 5000 });
      });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setNewGate((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleAddGate = () => {
    const { gate_name } = newGate;

    if (!gate_name) {
      toast.error('Sila masukkan nama pintu masuk', { autoClose: 5000 });
      return;
    }

    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      token: localStorage.getItem('token'),
    };

    API.post('/attendance/gateList', newGate, { headers })
      .then((response) => {
        if (response.data.response_code === 1000) {
          toast.success('Pintu masuk berjaya ditambah', { autoClose: 5000 });
          setNewGate({
            gate_name: '',
            description: '',
          });
          toggleAddGateModal();
          fetchGates();
        } else {
          toast.error(response.data.message || 'Gagal menambah pintu masuk', {
            autoClose: 5000,
          });
          toggleAddGateModal();
          fetchGates();
        }
      })
      .catch(() => {
        toast.error('Ralat semasa menambah pintu masuk', { autoClose: 5000 });
      });
  };

  useEffect(() => {
    fetchGates();
  }, []);

  const columns = [
    {
      name: 'ID',
      selector: (row) => row.id,
      sortable: true,
      center: true,
      width: '90px',
    },
    {
      name: 'Nama Pintu Masuk',
      selector: (row) => row.gate_name,
      sortable: true,
      center: true,
      grow: 2,
    },
    {
      name: 'Keterangan',
      selector: (row) => row.description || 'Tiada',
      sortable: true,
      center: true,
      grow: 2,
    },
    {
      name: 'Tarikh Dibuat',
      selector: (row) =>
        row.created_at
          ? moment.unix(row.created_at).format('DD-MMM-YYYY')
          : 'Tiada',
      sortable: true,
      center: true,
    },
    {
      name: 'Tindakan',
      cell: (row) => (
        <Button
          onClick={() => handleDeleteGate(row.id)}
          style={{
            backgroundColor: '#dc2626',
            color: '#ffffff',
            fontSize: '12px',
            fontWeight: 700,
            padding: '7px 14px',
            borderRadius: '10px',
            border: 'none',
            boxShadow: '0 8px 18px rgba(220, 38, 38, 0.22)',
          }}
        >
          Padam
        </Button>
      ),
      center: true,
    },
  ];

  const blueDataTableStyles = {
    table: {
      style: {
        borderRadius: '18px',
        overflow: 'hidden',
      },
    },
    headRow: {
      style: {
        backgroundColor: '#eff6ff',
        borderBottomColor: '#bfdbfe',
        minHeight: '56px',
      },
    },
    headCells: {
      style: {
        color: '#0B4C9C',
        fontSize: '12px',
        fontWeight: 900,
        textTransform: 'uppercase',
        letterSpacing: '0.06em',
      },
    },
    rows: {
      style: {
        minHeight: '60px',
        borderBottomColor: '#e5eefb',
        fontSize: '14px',
        color: '#0f172a',
      },
      highlightOnHoverStyle: {
        backgroundColor: '#eff6ff',
      },
    },
    pagination: {
      style: {
        borderTopColor: '#dbeafe',
        color: '#334155',
      },
    },
  };

  return (
    <Fragment>
      <ToastContainer theme="dark" />

      <div
        className="container-fluid"
        style={{
          background: 'linear-gradient(180deg, #f8fbff 0%, #eef6ff 100%)',
          minHeight: '100vh',
          paddingTop: '24px',
          paddingBottom: '40px',
        }}
      >
        <div className="row">
          <div className="col-xl-12 xl-100">
            <div
              className="card"
              style={{
                border: '1px solid #dbeafe',
                borderRadius: '22px',
                boxShadow: '0 18px 45px rgba(11, 76, 156, 0.10)',
                overflow: 'hidden',
              }}
            >
              <div
                className="card-header"
                style={{
                  background:
                    'linear-gradient(135deg, #0B4C9C 0%, #0F65C9 55%, #1E88E5 100%)',
                  borderBottom: 'none',
                  padding: '22px 26px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  gap: '16px',
                  flexWrap: 'wrap',
                }}
              >
                <div>
                  <div
                    style={{
                      color: '#bfdbfe',
                      fontSize: '12px',
                      fontWeight: 800,
                      letterSpacing: '0.12em',
                      textTransform: 'uppercase',
                      marginBottom: '6px',
                    }}
                  >
                    Tetapan Kehadiran
                  </div>

                  <h4
                    style={{
                      color: '#ffffff',
                      margin: 0,
                      fontWeight: 800,
                    }}
                  >
                    Senarai Pintu Masuk
                  </h4>

                  <p
                    style={{
                      color: '#dbeafe',
                      margin: '6px 0 0',
                      fontSize: '14px',
                    }}
                  >
                    Urus lokasi pintu masuk yang digunakan untuk rekod daftar
                    masuk kakitangan.
                  </p>
                </div>

                <Button
                  onClick={toggleAddGateModal}
                  style={{
                    backgroundColor: '#ffffff',
                    color: '#0B4C9C',
                    fontSize: '14px',
                    fontWeight: 800,
                    padding: '11px 18px',
                    borderRadius: '12px',
                    border: 'none',
                    boxShadow: '0 12px 25px rgba(15, 23, 42, 0.18)',
                  }}
                >
                  Tambah Pintu Masuk
                </Button>
              </div>

              <div
                className="card-body"
                style={{
                  backgroundColor: '#ffffff',
                  padding: '22px',
                }}
              >
                <div className="table-responsive">
                  <DataTable
                    columns={columns}
                    data={gates}
                    striped={false}
                    persistTableHead
                    pagination
                    highlightOnHover
                    customStyles={blueDataTableStyles}
                    noDataComponent={
                      <div
                        style={{
                          padding: '36px 16px',
                          color: '#64748b',
                          fontWeight: 600,
                        }}
                      >
                        Tiada pintu masuk direkodkan buat masa ini.
                      </div>
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal isOpen={modalAddGate} toggle={toggleAddGateModal}>
        <ModalHeader
          toggle={toggleAddGateModal}
          style={{
            backgroundColor: '#eff6ff',
            color: '#0B4C9C',
            borderBottom: '1px solid #bfdbfe',
            fontWeight: 800,
          }}
        >
          Tambah Pintu Masuk
        </ModalHeader>

        <ModalBody>
          <form>
            <div className="form-group mb-3">
              <label
                style={{
                  fontWeight: 700,
                  color: '#0f172a',
                  marginBottom: '6px',
                }}
              >
                Nama Pintu Masuk
              </label>
              <input
                type="text"
                name="gate_name"
                className="form-control"
                placeholder="Contoh: Pintu Utama"
                value={newGate.gate_name}
                onChange={handleInputChange}
                required
                style={{
                  borderRadius: '12px',
                  borderColor: '#bfdbfe',
                  padding: '10px 12px',
                }}
              />
            </div>

            <div className="form-group">
              <label
                style={{
                  fontWeight: 700,
                  color: '#0f172a',
                  marginBottom: '6px',
                }}
              >
                Keterangan
              </label>
              <input
                type="text"
                name="description"
                className="form-control"
                placeholder="Contoh: Laluan utama kakitangan"
                value={newGate.description}
                onChange={handleInputChange}
                style={{
                  borderRadius: '12px',
                  borderColor: '#bfdbfe',
                  padding: '10px 12px',
                }}
              />
            </div>
          </form>
        </ModalBody>

        <ModalFooter
          style={{
            borderTop: '1px solid #e2e8f0',
            backgroundColor: '#f8fafc',
          }}
        >
          <Button
            onClick={handleAddGate}
            style={{
              backgroundColor: '#0B4C9C',
              color: '#ffffff',
              fontWeight: 800,
              border: 'none',
              borderRadius: '10px',
              padding: '9px 16px',
            }}
          >
            Simpan
          </Button>

          <Button
            onClick={toggleAddGateModal}
            style={{
              backgroundColor: '#e2e8f0',
              color: '#334155',
              fontWeight: 800,
              border: 'none',
              borderRadius: '10px',
              padding: '9px 16px',
            }}
          >
            Batal
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

export default GatePage;